var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAggregatedAudits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3327 19.8333C18.5963 19.8333 17.9993 20.4302 17.9993 21.1666C17.9993 21.903 18.5963 22.5 19.3327 22.5H28.666C29.4024 22.5 29.9993 21.903 29.9993 21.1666C29.9993 20.4302 29.4024 19.8333 28.666 19.8333H19.3327Z",
    fill: "#0B0B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 21.1666C13.9993 20.4302 14.5963 19.8333 15.3327 19.8333C16.0691 19.8333 16.666 20.4302 16.666 21.1666C16.666 21.903 16.0691 22.5 15.3327 22.5C14.5963 22.5 13.9993 21.903 13.9993 21.1666Z",
    fill: "#0B0B17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3327 25.1666C18.5963 25.1666 17.9993 25.7636 17.9993 26.5C17.9993 27.2363 18.5963 27.8333 19.3327 27.8333H28.666C29.4024 27.8333 29.9993 27.2363 29.9993 26.5C29.9993 25.7636 29.4024 25.1666 28.666 25.1666H19.3327Z",
    fill: "#0B0B17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 26.5C13.9993 25.7636 14.5963 25.1666 15.3327 25.1666C16.0691 25.1666 16.666 25.7636 16.666 26.5C16.666 27.2363 16.0691 27.8333 15.3327 27.8333C14.5963 27.8333 13.9993 27.2363 13.9993 26.5Z",
    fill: "#0B0B17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.666 9.16663C29.4024 9.16663 29.9993 9.76358 29.9993 10.5C32.9449 10.5 35.3327 12.8878 35.3327 15.8333V30.5C35.3327 33.4455 32.9449 35.8333 29.9993 35.8333H15.6562C14.2417 35.8333 12.8852 35.2714 11.885 34.2712L10.2281 32.6143C9.22792 31.6141 8.66602 30.2576 8.66602 28.8431V15.8333C8.66602 12.8878 11.0538 10.5 13.9993 10.5C13.9993 9.76358 14.5963 9.16663 15.3327 9.16663H28.666ZM13.9993 13.1666C12.5266 13.1666 11.3327 14.3605 11.3327 15.8333V28.8431C11.3327 29.5503 11.6136 30.2286 12.1137 30.7287L13.7706 32.3856C14.2707 32.8857 14.949 33.1666 15.6562 33.1666H29.9993C31.4721 33.1666 32.666 31.9727 32.666 30.5V15.8333C32.666 14.3605 31.4721 13.1666 29.9993 13.1666C29.9993 13.903 29.4024 14.5 28.666 14.5H15.3327C14.5963 14.5 13.9993 13.903 13.9993 13.1666Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggregatedAudits);
export default __webpack_public_path__ + "static/media/aggregated-audits.d7aa7e6d0e7327be9bbf3567d906da2d.svg";
export { ForwardRef as ReactComponent };